import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import StripeService from "../services/stripe.service";
import { getGameList } from "../constants/GameListAdapter";
import { useLocation } from "react-router-dom";
import { setDiscount, } from "actions/discount";

import styles from "./DiscountReaderStyles.module.scss";


export default function DiscountReader() {
    const [promoCodeValid, setPromoCodeValid] = useState(false);
    const [promoCodeMessage, setPromoCodeMessage] = useState("");

    const { items, } = useSelector(state => state.cart);
    const location = useLocation(); 
    const dispatch = useDispatch();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.has("discountCode")) {
            checkPromotionCode(queryParams.get("discountCode"));
        }
    }, [location.search]);

    const checkPromotionCode = (promoCode) => {
        console.log("Checking Promo Code : ", promoCode);
        if (promoCode.length > 0) {
            const productIds = getGameList().map((x) => x.productId);

            StripeService.checkPromotionCode(promoCode, productIds)
                .then((res) => {
                    console.log("Check promo code res: ", res);
                    if (res.data.valid === true) {
                        if (res.data.applicableProductIds.length > 0) {
                            const applicableProducts = getGameList().filter((x) => res.data.applicableProductIds.includes(x.productId));
                            const applicableProductNames = applicableProducts.map((x) => x.name);

                            setPromoCodeMessage(`Your discount code '${promoCode}' for ${res.data.percentOff}% off, will be applied at checkout for: ${applicableProductNames.join(", ")}!`);

                        } else {
                            setPromoCodeMessage(`Your discount code '${promoCode}' for ${res.data.percentOff}% off, will be applied at checkout!`);
                        }
                        setPromoCodeValid(true);
                        dispatch(setDiscount(promoCode));
                    }
                }).catch((err) => {
                    console.log("Check promo code err: ", err);
                    setPromoCodeValid(false);
                    setPromoCodeMessage("");
                });
        }
    }

    const showTempNotification = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startDate = new Date('2024-11-21T00:00:00');
        const endDate = new Date('2024-12-03T23:59:59');

        if (today >= startDate && today <= endDate) {
            return true;
        } else {
            return false
        }
    }

    return (
        <>
            {
                promoCodeValid && !location.pathname.includes("/lobby") &&
                    <header className={styles.appNotification}>{promoCodeMessage}</header>
                    //:
                    //showTempNotification() ?
                    //    <header className={styles.appNotification} style={{ 'backgroundColor': "black" }}>USE CODE 'FRIDAY30' FOR 30% OFF AT CHECKOUT</header>
                    //    :
                    //    null
            }
        </>
    );
}